import React from 'react';
import { Select } from '@chakra-ui/react';
import { quizLocales } from '@/features/Quiz/utils/quizLocales';

type Props = {
    value: string;
    onChange: (locale: string) => void;
};

export const LocaleFilter: React.FC<Props> = ({ value, onChange }) => (
    <Select
        bg="white"
        borderRadius="1000px"
        borderColor="gray.200"
        fontSize="sm"
        fontWeight="normal"
        h="2.5rem"
        w="200px"
        flexShrink={0}
        value={value}
        onChange={(e) => onChange(e.target.value)}>
        <option value="">All Languages</option>
        {quizLocales.map((lang) => (
            <option key={lang.key} value={lang.key}>
                {lang.name}
            </option>
        ))}
    </Select>
);
